import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { PerfilError } from '../models/perfil-error.model';
import { GlobalConstants } from '../../global-constants';
//import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class PerfilStatusService {
  // URL base de la REST API de WordPress (inyectada o global)
  private apiUrl = GlobalConstants.urlBase + '/wp-json/custom/v1/perfil-errores';
  
  // El BehaviorSubject arranca con un array vacío de errores
  private erroresSubject = new BehaviorSubject<PerfilError[]>([]);
  public errores$: Observable<PerfilError[]> = this.erroresSubject.asObservable();

  constructor(private http: HttpClient/*, private toastr: ToastrService*/) {
    // Escuchar eventos globales del DOM de otros Web Elements (Plugins de Angular)
    window.addEventListener('perfilDataUpdated', () => {
      this.cargarErroresDesdeBackend();
    });
  }

  // Método para ir a buscar los errores guardados en la tabla caché de MySQL
  public cargarErroresDesdeBackend(): void {
    // 1. Intentamos recuperar el Nonce que genera WordPress automáticamente
    const wpNonce = (window as any).wpApiSettings?.nonce || '';

    // 2. Configuramos las cabeceras obligatorias para la API de WP
    const headers = { 
      'X-WP-Nonce': wpNonce
    };

    // 3. Ejecutamos el GET incluyendo 'withCredentials' para arrastrar las cookies de sesión
    this.http.get<PerfilError[]>(this.apiUrl, { 
      headers: headers,
      withCredentials: true // <--- ¡CRUCIAL para entornos locales y sesiones PHP!
    }).subscribe({
      next: (errores) => {
        this.erroresSubject.next(errores);
        //if (errores != undefined && errores.length > 0)
        //  this.toastr.error('Tu perfil aún no está visible. Revisa y corrige los datos marcados para que podamos publicarlo');
      },
      error: (err) => console.error('Error obteniendo validaciones', err)
    });
  }

  // Método que un Web Element puede llamar si está dentro del mismo paquete de Angular
  public notificarCambioLocal(): void {
    // Emitimos evento al DOM por si hay otros Web Elements en otras partes de la página
    const evento = new CustomEvent('perfilDataUpdated');
    window.dispatchEvent(evento);
  }
}